// typewriter-on-view.js
(function () {
    function register(Alpine) {
        // Prevent double-registration in HMR/multiple includes
        if (Alpine.__typewriterOnViewRegistered) return;
        Alpine.__typewriterOnViewRegistered = true;

        Alpine.data('typewriterOnView', (opts = {}) => ({
            // Defaults
            duration: 2000,
            delay: 0,
            once: true,
            atomicTags: ['A'],
            // Internals
            _observer: null,
            _hasRun: false,
            _reduced: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false,
            _tokens: [],
            _totalSteps: 0,

            init() {
                Object.assign(this, opts);
                this._prepareDOM();
                this._observeFor20px();
            },

            _observeFor20px() {
                this._observer = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (!entry.isIntersecting) continue;
                        const r = entry.intersectionRect;
                        if (r && r.width >= 20 && r.height >= 20) {
                            if (this.once) this._observer.disconnect();
                            this._start();
                            break;
                        }
                    }
                }, { threshold: [0, 0.01, 0.1, 0.25, 0.5, 1] });
                this._observer.observe(this.$root);
            },

            _prepareDOM() {
                if (this._reduced) return;
                const atomicSet = new Set(this.atomicTags.map(t => String(t).toUpperCase()));
                const tokens = [];
                const splitTextToSpans = (text) => {
                    let segments = [];
                    if (typeof Intl !== 'undefined' && Intl.Segmenter) {
                        const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
                        segments = Array.from(seg.segment(text), s => s.segment);
                    } else {
                        segments = Array.from(text);
                    }
                    const frag = document.createDocumentFragment();
                    for (const ch of segments) {
                        const span = document.createElement('span');
                        span.textContent = ch;
                        span.style.opacity = '0';
                        span.style.transition = 'opacity 0ms linear';
                        span.style.willChange = 'opacity';
                        frag.appendChild(span);
                        tokens.push(span);
                    }
                    return frag;
                };
                const processNode = (node) => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        const text = node.nodeValue || '';
                        if (!text) return;
                        const frag = splitTextToSpans(text);
                        node.replaceWith(frag);
                        return;
                    }
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const tag = node.tagName.toUpperCase();
                        if (atomicSet.has(tag)) {
                            const wrapper = document.createElement('span');
                            wrapper.style.opacity = '0';
                            wrapper.style.willChange = 'opacity';
                            node.parentNode.insertBefore(wrapper, node);
                            wrapper.appendChild(node);
                            tokens.push(wrapper);
                            return;
                        }
                        for (const child of Array.from(node.childNodes)) processNode(child);
                    }
                };
                processNode(this.$root);
                this._tokens = tokens;
                this._totalSteps = tokens.length;
            },

            _start() {
                if (this._hasRun && this.once) return;
                this._hasRun = true;
                if (this._reduced) return;
                const tokens = this._tokens;
                const N = this._totalSteps || 0;
                if (!N) return;
                const interval = Math.max(1, Math.floor(this.duration / N));
                requestAnimationFrame(() => {
                    const kick = () => {
                        let i = 0;
                        const revealNext = () => {
                            if (i >= N) return;
                            const el = tokens[i++];
                            el.style.opacity = '1';
                            setTimeout(() => { el.style.willChange = ''; }, 50);
                            if (i < N) setTimeout(revealNext, interval);
                        };
                        revealNext();
                    };
                    this.delay > 0 ? setTimeout(kick, this.delay) : kick();
                });
            }
        }));
    }

    // Register now if Alpine is already on the page; otherwise wait for init.
    if (window.Alpine) {
        register(window.Alpine);
    } else {
        document.addEventListener('alpine:init', () => register(window.Alpine));
    }
})();
